<div class="container-fluid section pt-3 pb-2">
    <span class="header">FAQs</span>
    <div *ngIf="faqs.length">
        <div class="sub-section py-2 px-3 my-2" *ngFor="let faq of faqs; let i = index">
            <div class="d-flex flex-row justify-content-between">
                <span class="sub-title">{{faq?.question}}</span>
                <div class="fas mt-1 ml-4 collapsed" data-toggle="collapse" [attr.data-target]="'#collapse-faq-' + i"></div>
            </div>
            <div [attr.id]="'collapse-faq-' + i" class="collapse">
                <div class="horizontal-line my-2"></div>
                <span class="section-text">{{faq?.answer}}</span>
            </div>
        </div>
    </div>
    <div class="no-data pt-5" *ngIf="!faqs.length">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Faqs">
        <span>No faqs</span>
    </div>
</div>